const useDownloadCsv = () => ({
  formatAndDownload: (fileName, headers, items) => {
    import(/* webpackChunkName: "file-saver" */ "file-saver").then(({ default: saveAs }) => {
      const headersStr = headers.join(",");
      const itemsStr = items.map((row) => row.join(",")).join("\n");
      window.headersStr = headersStr;
      window.itemsStr = itemsStr;
      const blob = new Blob([headersStr, "\n", itemsStr], { type: "text/plain;charset=utf-8" });

      saveAs(blob, fileName);
    });
  }
});

export default useDownloadCsv;
